import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import httpClient from "../../custom-hooks/httpClient";
import { toast } from "react-toastify";
import Select from "react-select";
import Loader from "react-loader-spinner";

function UserRegistration() {
  const history = useHistory();
  const location = useLocation();
  const securityPin =
    location.state && location.state.securityPin
      ? location.state.securityPin
      : "";
  const confirmSecurityPin =
    location.state && location.state.confirmSecurityPin
      ? location.state.confirmSecurityPin
      : "";

  const [userData, setUserData] = useState({
    gender: "",
    address: "",
    state_id: "",
    pin: securityPin,
    confirm_pin: confirmSecurityPin,
    lga_id: "",
    referrer_code: sessionStorage.getItem("referral_code") || "",
  });

  const [states, setStates] = useState([]);
  const [localGovts, setLocalGovts] = useState([]);
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  // Handle change for react-select dropdowns and native HTML input elements.
  const handleChange = (event, { name }) => {
    let value = event.target ? event.target.value : event.value;
    // Handle referrer code if not provided or undefined.
    if (name === "referrer_code" && value === undefined) {
      value = "";
    }
    setUserData({ ...userData, [name]: value.toString() });
  };

  useEffect(() => {
    const { referrer_code, email, ...fields } = userData;
    const areFieldsSet = Object.values(fields).every((value) => value !== "");
    setAreFieldsSet(areFieldsSet);
  }, [userData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    httpClient
      .post(`/users`, userData)
      .then(({ status, data }) => {
        if (status === 200) {
          localStorage.setItem("id", data.id);
          toast.success(
            data.message || "Yaay! Your account creation was successful.",
          );
          history.push("/login");
        }
        setIsSubmitting(false);
      })
      .catch((err) => {
        const errorMessage =
          err.response && err.response.data
            ? err.response.data.message
            : "An Error Occured";
        toast.error(errorMessage);
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    httpClient
      .get(`/states`)
      .then(({ status, data }) => {
        if (status === 200) {
          setStates(data.states);
        }
      })
      .catch((err) => {
        const errorMessage =
          err.response && err.response.data
            ? err.response.data.message
            : "Error getting list of states";
        toast.error(errorMessage);
      });
  }, []);

  useEffect(() => {
    if (userData.state_id) {
      httpClient
        .get(`/local-government?stateId=${userData.state_id}`)
        .then(({ status, data }) => {
          if (status === 200) {
            setLocalGovts(data.localGovts);
          }
        })
        .catch((err) => {
          const errorMessage =
            err.response && err.response.data
              ? err.response.data.message
              : "Error getting list of local governments";
          toast.error(errorMessage);
        });
    }
  }, [userData.state_id]);

  return (
    <>
      <section className="section-border border-primary">
        <div className="container d-flex flex-column">
          <div className="row align-items-center justify-content-center gx-0 min-vh-100">
            <div className="col-12 col-md-10 col-lg-9 py-8 py-md-11">
              <h1 className="mb-0 fw-bold text-center text-primary">
                Account Setup
              </h1>

              <p className="mb-6 text-center text-muted">
                Tell us a little about you.
              </p>

              <form className="mb-6" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="address">
                    Residential Address
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-user"
                    name="address"
                    id="address"
                    placeholder="Residential Address"
                    onChange={(e) => handleChange(e, { name: "address" })}
                    required
                    aria-label="Enter your residential address"
                    aria-required="true"
                  />
                </div>
                <div className="form-group row">
                  <div className="col-sm-4 mb-3 mb-sm-0">
                    <label className="form-label" htmlFor="state_id">
                      State
                    </label>
                    <Select
                      id="state_id"
                      name="state_id"
                      onChange={handleChange}
                      options={states.map((state) => ({
                        value: state.id,
                        label: state.name,
                      }))}
                      aria-label="Select your state of residence"
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="col-sm-4 mb-3 mb-sm-0">
                    <label className="form-label" htmlFor="lga_id">
                      Local Govt Area
                    </label>
                    <Select
                      id="lga_id"
                      name="lga_id"
                      onChange={handleChange}
                      options={localGovts.map((lg) => ({
                        value: lg.id,
                        label: lg.local_government_name,
                      }))}
                      required
                      aria-label="Select your local government"
                      aria-required="true"
                    />
                  </div>
                  <div className="col-sm-4 mb-3 mb-sm-0">
                    <label className="form-label" htmlFor="gender">
                      Gender
                    </label>
                    <Select
                      id="gender"
                      name="gender"
                      options={genderOptions}
                      onChange={handleChange}
                      required
                      aria-label="Select your gender"
                      aria-required="true"
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6 mb-3 mb-sm-0">
                    <label className="form-label" htmlFor="email">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-user"
                      name="email"
                      id="email"
                      value={userData.email}
                      onChange={(e) => handleChange(e, { name: "email" })}
                      placeholder="Enter your email address"
                      aria-label="Enter your email address"
                    />
                  </div>
                  <div className="col-sm-6 mb-3 mb-sm-0">
                    <label className="form-label" htmlFor="referrer_code">
                      Referrer Code
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-user"
                      name="referrer_code"
                      id="referrer_code"
                      value={userData.referrer_code}
                      onChange={(e) =>
                        handleChange(e, { name: "referrer_code" })
                      }
                      placeholder="Enter referrer code"
                      aria-label="Enter referrer code"
                    />
                  </div>
                </div>

                {areFieldsSet ? (
                  isSubmitting ? (
                    <button
                      className="btn w-100 btn-primary mt-3"
                      type="button"
                      disabled
                      aria-label="Processing registration"
                    >
                      <Loader type="Oval" color="#fff" width={20} height={20} />
                    </button>
                  ) : (
                    <button
                      className="btn w-100 btn-primary mt-3"
                      type="submit"
                      aria-label="Submit registration form"
                    >
                      Next
                    </button>
                  )
                ) : (
                  <button
                    className="btn w-100 btn-primary mt-3"
                    type="button"
                    disabled
                  >
                    Next
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>{" "}
    </>
  );
}

export default UserRegistration;
